import { SafeDictionary } from "@insite/client-framework/Common/Types";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import {
    createHandlerChainRunner,
    Handler,
    HasOnSuccess,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import {
    AddressFieldDisplayCollectionModel,
    AddressFieldDisplayModel,
    BaseAddressModel,
    CustomerValidationDto,
} from "@insite/client-framework/Types/ApiModels";
import { chain, ValidatePostalCode, ValidateFax } from "@insite/client-framework/Store/CommonHandlers/ValidateAddress";
import validators from "@tSurya/Common/Utilities/validations";

export type AddressErrors = SafeDictionary<React.ReactNode>;
type HandlerType = Handler<
    {
        address: BaseAddressModel;
        validationRules: CustomerValidationDto;
        addressFieldDisplayCollection: AddressFieldDisplayCollectionModel;
    } & HasOnSuccess<AddressErrors>,
    {
        addressErrors: AddressErrors;
    }
>;
const isEmpty = (value: string) => value.trim().length <= 0;
const getRequiredErrorMessage = (addressFieldDisplayCollection: AddressFieldDisplayModel) =>
    siteMessage("Field_Required", addressFieldDisplayCollection.displayName);
export const ValidatePostalCodeExtended: HandlerType = props => {
    const { validationRules, addressFieldDisplayCollection } = props.parameter;
    const { country, postalCode } = props.parameter.address;
    if (
        addressFieldDisplayCollection.postalCode?.isVisible &&
        validationRules.postalCode?.isRequired &&
        isEmpty(postalCode)
    ) {
        props.addressErrors.postalCode = getRequiredErrorMessage(addressFieldDisplayCollection.postalCode);
    } else if (!validators.postalCode(postalCode, country?.abbreviation)) {
        props.addressErrors.postalCode = siteMessage("Invalid PostalCode");
    }
};
export const ValidateFaxExtended: HandlerType = props => {};
replaceInChain(chain, ValidatePostalCode, ValidatePostalCodeExtended);
replaceInChain(chain, ValidateFax, ValidateFaxExtended);
